import type { UppFloorPlanVertex } from '../plan/floor-plan-element';

/**
 * Axis-aligned vertex marker box in **content-group px** (model `xCm`/`yCm`/`widthCm`/`heightCm`).
 * Used for label placement when the Konva node is a circle at the centre, not a rect.
 */
export function floorPlanVertexLabelRectCornersContentPx(
  el: UppFloorPlanVertex,
  scalePxPerCm: number,
): Array<{ x: number; y: number }> {
  const x = el.xCm * scalePxPerCm;
  const y = el.yCm * scalePxPerCm;
  const w = el.widthCm * scalePxPerCm;
  const h = el.heightCm * scalePxPerCm;
  return [
    { x, y },
    { x: x + w, y },
    { x: x + w, y: y + h },
    { x, y: y + h },
  ];
}

/**
 * English comment normalized.
 * English comment normalized.
 */
export function pickStageTopRightCornerAmongVertices(
  cornersStage: ReadonlyArray<{ x: number; y: number }>,
): { x: number; y: number } {
  const first = cornersStage[0];
  if (!first) {
    return { x: 0, y: 0 };
  }
  let best = first;
  for (const p of cornersStage) {
    if (p.y < best.y - 1e-6 || (Math.abs(p.y - best.y) <= 1e-6 && p.x > best.x)) {
      best = p;
    }
  }
  return best;
}
